import { Box, ModBox, ModalDialog } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { SubmittingComponent } from '../../../components/SubmittingComponent'
import { useLazyApiData, useStores } from '../../../data/store'
import { styles } from '../../Checker'
import { StatusData } from './comps/StatusData'
import { StatusStateIcon } from './comps/StatusStateIcon'

interface CheckerStatusProps {
  isCheckerApproved: boolean
  data: any
  onSubmit: any
}

const Footer = ({ onSubmit }: any) => {
  return <ButtonNew onPress={onSubmit} title={'Go to My Queue'} height={40} width={180} color={'PRIMARY'} />
}

const CheckerStatus: FC<CheckerStatusProps> = ({ isCheckerApproved, data, onSubmit }: CheckerStatusProps) => {
  console.log('CheckerStatus data', JSON.parse(JSON.stringify(data)))

  const {
    checkStatus,
    getApplicationIdFromTaskId,
    getApplicationApprovalstatus,
    checkerApplicationStatus,
    applicationRetry,
    applicationStatusFromApi,
    statusCallCount,
  } = useStores((store) => ({
    checkStatus: store.checkApplicationStatus,
    getApplicationIdFromTaskId: store.getApplicationIdFromTaskId,
    getApplicationApprovalstatus: store.getApplicationApprovalstatus(),
    checkerApplicationStatus: store.checkerApplicationStatus,
    applicationRetry: store.applicationRetry,
    applicationStatusFromApi: store.checkerApplicationStatus.applicationStatus,
    statusCallCount: store.checkerApplicationStatus.callCount,
  }))

  const [fetchCheckStatusApi, fetchCheckStatusApiHandler] = useLazyApiData(checkStatus)
  const [retryApi, applicationRetryHandler] = useLazyApiData(applicationRetry)

  const [showRetryingLoader, setShowRetryingLoader] = useState(false)
  const [approvedDate, setApprovedDate] = useState('')

  const [applicationStatus, setApplicationStatus] = useState(false)
  const [statusData, setStatusData] = useState({
    applicationStatus: data?.data?.applicationStatus ?? '',
    applicationId: data?.data?.applicationId ?? '',
    legalName: data?.data?.legalName ?? '',
    channelId: data?.data?.channelId ?? '',
    identificationNumber: data?.data?.identificationNumber ?? '',
    inProgressTask: data?.data?.inProgressTask ?? '',
    completedTaskList: data?.data?.completedTaskList ?? [],
    errorReason: data?.data?.errorReason ?? '',
    applicationType: data?.data?.applicationType ?? '',
    errorTask: data?.data?.errorTask ?? '',
    jfsUserid: data?.data?.jfsUserid ?? '',
    comments: data?.data?.comments ?? '',
    creationDate: data?.data?.creationDate ?? '',
  })

  const getLocaleDateString = () => {
    const date = new Date().toLocaleString()
    if (approvedDate === '' && approvedDate !== date) {
      setApprovedDate(date)
    }
    return date
  }

  useEffect(() => {
    if (approvedDate === '') {
      setApprovedDate(new Date().toLocaleString())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    const applicationId = getApplicationIdFromTaskId(data?.data?.applicationId)
    if (applicationId.length > 0) {
      fetchCheckStatusApi(applicationId, null)
    }
  }, [data, fetchCheckStatusApi, getApplicationIdFromTaskId])

  useEffect(() => {
    if (statusCallCount > 0) {
      console.log('applicationStatus: ', statusCallCount)
      setApplicationStatus(applicationStatusFromApi)
      if (checkerApplicationStatus?.applicationId?.length > 0) {
        setStatusData(checkerApplicationStatus)
      }
    }
  }, [applicationStatusFromApi, checkerApplicationStatus, statusCallCount, statusData?.applicationId])

  useEffect(() => {
    if (applicationRetryHandler?.state === 'fulfilled' || applicationRetryHandler?.state === 'rejected') {
      if (applicationRetryHandler?.state === 'fulfilled' && applicationRetryHandler?.data?.status === 'Success') {
        const applicationId = statusData?.applicationId
        if (applicationId?.length > 0) {
          setStatusData({
            applicationStatus: '',
            applicationId: '',
            legalName: '',
            channelId: '',
            identificationNumber: '',
            inProgressTask: '',
            completedTaskList: [],
            errorReason: '',
            applicationType: '',
            errorTask: '',
            jfsUserid: '',
            comments: '',
            creationDate: '',
          })
          fetchCheckStatusApi(applicationId, false)
        }
      }
      if (applicationRetryHandler?.state === 'rejected') {
        setShowRetryingLoader(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    applicationRetryHandler.data?.status,
    applicationRetryHandler.state,
    data?.data?.applicationId,
    fetchCheckStatusApi,
    getApplicationIdFromTaskId,
  ])

  useEffect(() => {
    if (fetchCheckStatusApiHandler?.state === 'fulfilled') {
      if (fetchCheckStatusApiHandler?.data && fetchCheckStatusApiHandler?.data?.applicationStatus) {
        if (
          fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'completed' ||
          fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'error'
        ) {
          setStatusData(fetchCheckStatusApiHandler?.data)
          setShowRetryingLoader(false)
        } else if (
          fetchCheckStatusApiHandler?.data?.applicationStatus?.toLowerCase() === 'rejected' &&
          statusData?.comments?.length === 0
        ) {
          setStatusData({ ...statusData, comments: fetchCheckStatusApiHandler?.data?.comments })
        }
      }
    } else if (fetchCheckStatusApiHandler?.state === 'rejected') {
      setShowRetryingLoader(false)
    }
  }, [fetchCheckStatusApiHandler?.data, fetchCheckStatusApiHandler?.state, statusData])

  useEffect(() => {
    if (
      getApplicationApprovalstatus &&
      getApplicationApprovalstatus.length > 0 &&
      getApplicationApprovalstatus === 'Error' &&
      statusData?.applicationId === ''
    ) {
      setShowRetryingLoader(false)
    }
  }, [checkerApplicationStatus, getApplicationApprovalstatus, statusData, statusData?.applicationId])

  const onApplicationRetry = () => {
    if (statusData?.applicationId?.length > 0) {
      retryApi(statusData?.applicationId, false, '')
      setShowRetryingLoader(false)
    }
  }

  const getCreationType = (type: string) => {
    const allTypes = {
      GROUP_ADD: 'Group',
      SUBGROUP_ADD: 'SubGroup',
      ENTITY_ADD: 'Entity',
    }
    return allTypes[type]
  }

  const onDismiss = () => {
    setShowRetryingLoader(false)
  }

  const getMessage = (taskType: string) => {
    const msgObj = {
      emsExternalTask: 'Please wait, we are creating Entity for you',
      userRegistrationExternalTask: 'Please wait, we are creating User for you',
      configExternalTask: 'Please wait, we are creating Configurations for you',
      apigOnBoardingExternalTask: 'Please wait, we are Onboarding into API Gateway',
      channelIdConfigExternalTask: 'Please wait, we are creating Channel ID for you',
    }
    return msgObj[taskType] ?? 'Please wait, we are processing your request…'
  }

  const getErrorReason = (errorReason: any) => {
    try {
      return errorReason && JSON?.parse(errorReason)?.error?.message
    } catch (e) {
      return errorReason
    }
  }

  return (
    <>
      <ModBox {...styles.container}>
        <Box alignItems={'center'} justifyContent={'center'} w={'100%'} h={'100%'}>
          <Box direction="row" alignItems={'center'}>
            <Box marginTop={64} alignItems={'center'} h={'100%'}>
              <Box direction="row">
                <StatusStateIcon
                  isApproved={isCheckerApproved && statusData?.applicationStatus?.toLowerCase() !== 'rejected'}
                  show={isCheckerApproved || statusData?.errorReason?.length === 0}
                  isProgress={false}
                  status={'completed'}
                />
                <StatusData
                  isApproved={isCheckerApproved}
                  title={
                    isCheckerApproved && statusData?.applicationStatus?.toLowerCase() !== 'rejected'
                      ? 'Approved by checker'
                      : 'Rejected by checker'
                  }
                  subTitleKey={
                    isCheckerApproved && statusData?.applicationStatus?.toLowerCase() !== 'rejected'
                      ? 'Approved on: '
                      : 'Rejected on: '
                  }
                  subTitleValue={
                    isCheckerApproved &&
                    statusData?.applicationStatus?.toLowerCase() !== 'rejected' &&
                    statusData?.creationDate?.length > 0
                      ? statusData?.creationDate
                      : statusData?.applicationStatus?.toLowerCase() === 'rejected'
                      ? statusData?.creationDate
                      : getLocaleDateString()
                  }
                  subSubTitleKey={
                    isCheckerApproved && statusData?.applicationStatus?.toLowerCase() !== 'rejected' ? '' : 'Comments: '
                  }
                  subSubTitleValue={
                    isCheckerApproved && statusData?.applicationStatus?.toLowerCase() !== ' V'
                      ? ''
                      : statusData?.comments ?? ''
                  }
                  applicationId={statusData?.applicationId}
                  show={isCheckerApproved || statusData?.errorReason?.length === 0}
                />
              </Box>
              <Box direction="row" alignSelf={'flex-start'}>
                <StatusStateIcon
                  isApproved={statusData?.applicationStatus?.toLowerCase() === 'completed'}
                  isProgress={
                    !['completed', 'failed', 'rejected', 'error'].includes(statusData?.applicationStatus?.toLowerCase())
                  }
                  status={statusData?.applicationStatus}
                  show={!['rejected'].includes(statusData?.applicationStatus?.toLowerCase())}
                />
                <StatusData
                  isApproved={statusData?.applicationStatus?.toLowerCase() === 'completed'}
                  title={
                    statusData?.applicationStatus?.toLowerCase() === 'completed'
                      ? `${getCreationType(statusData?.applicationType)} Created successfully`
                      : getErrorReason(statusData?.errorReason)
                  }
                  subTitleKey={`${getCreationType(statusData?.applicationType)} ID: `}
                  subTitleValue={statusData?.identificationNumber}
                  subSubTitleKey={'Business Name: '}
                  subSubTitleValue={statusData?.legalName}
                  show={['completed', 'failed', 'error'].includes(statusData?.applicationStatus?.toLowerCase())}
                />
              </Box>
              <ModBox show={statusData?.applicationType === 'ENTITY_ADD' && false}>
                <Box direction="row">
                  <StatusStateIcon
                    isApproved={
                      statusData?.completedTaskList?.length > 0 &&
                      statusData?.completedTaskList?.includes('userRegistrationExternalTask') &&
                      isCheckerApproved
                    }
                    show={
                      (statusData?.completedTaskList?.length > 0 &&
                        statusData?.completedTaskList?.includes('userRegistrationExternalTask')) ||
                      statusData?.errorTask === 'userRegistrationExternalTask' ||
                      statusData?.inProgressTask === 'userRegistrationExternalTask'
                    }
                    isProgress={
                      statusData?.inProgressTask === 'userRegistrationExternalTask' &&
                      statusData?.errorTask !== 'userRegistrationExternalTask'
                    }
                    status={applicationStatus}
                  />
                  <StatusData
                    isApproved={
                      statusData?.completedTaskList?.includes('userRegistrationExternalTask') && isCheckerApproved
                    }
                    title={
                      statusData?.completedTaskList?.includes('userRegistrationExternalTask') && isCheckerApproved
                        ? 'Default user is created'
                        : getErrorReason(statusData?.errorReason)
                    }
                    subTitleKey={'User ID: '}
                    subTitleValue={statusData?.jfsUserid}
                    subSubTitleKey={''}
                    subSubTitleValue={''}
                    show={
                      statusData?.completedTaskList?.includes('userRegistrationExternalTask') ||
                      statusData?.errorTask === 'userRegistrationExternalTask' ||
                      statusData?.inProgressTask === 'userRegistrationExternalTask'
                    }
                  />
                </Box>
                <Box direction="row">
                  <StatusStateIcon
                    isApproved={statusData?.completedTaskList?.includes('configExternalTask') && isCheckerApproved}
                    show={
                      (statusData?.completedTaskList?.length > 0 &&
                        statusData?.completedTaskList?.includes('configExternalTask')) ||
                      statusData?.errorTask === 'configExternalTask' ||
                      statusData?.inProgressTask === 'configExternalTask'
                    }
                    isProgress={
                      statusData?.inProgressTask === 'configExternalTask' &&
                      statusData?.errorTask !== 'configExternalTask'
                    }
                    status={applicationStatus}
                  />
                  <StatusData
                    isApproved={statusData?.completedTaskList?.includes('configExternalTask') && isCheckerApproved}
                    title={'Config Creation Status'}
                    subTitleKey={statusData?.completedTaskList?.includes('configExternalTask') ? 'Status: ' : ''}
                    subTitleValue={statusData?.completedTaskList?.includes('configExternalTask') ? 'Created' : ''}
                    subSubTitleKey={statusData?.completedTaskList?.includes('configExternalTask') ? '' : 'Status: '}
                    subSubTitleValue={
                      statusData?.completedTaskList?.includes('configExternalTask')
                        ? ''
                        : statusData?.errorReason?.length > 0
                        ? getErrorReason(statusData?.errorReason) ?? statusData?.errorReason
                        : ''
                    }
                    show={
                      statusData?.completedTaskList?.includes('configExternalTask') ||
                      statusData?.errorTask === 'configExternalTask' ||
                      statusData?.inProgressTask === 'configExternalTask'
                    }
                  />
                </Box>
                <Box direction="row">
                  <StatusStateIcon
                    isApproved={
                      (statusData?.completedTaskList?.includes('apigOnBoardingExternalTask') ||
                        statusData?.completedTaskList?.includes('APIGOnBoardingExternalTask')) &&
                      isCheckerApproved
                    }
                    show={
                      (statusData?.completedTaskList?.length > 0 &&
                        (statusData?.completedTaskList?.includes('apigOnBoardingExternalTask') ||
                          statusData?.completedTaskList?.includes('APIGOnBoardingExternalTask'))) ||
                      statusData?.inProgressTask === 'apigOnBoardingExternalTask' ||
                      statusData?.inProgressTask === 'APIGOnBoardingExternalTask' ||
                      statusData?.errorTask === 'apigOnBoardingExternalTask' ||
                      statusData?.errorTask === 'APIGOnBoardingExternalTask' ||
                      statusData?.inProgressTask === 'apigOnBoardingExternalTask'
                    }
                    isProgress={
                      (statusData?.inProgressTask === 'apigOnBoardingExternalTask' &&
                        statusData?.errorTask !== 'apigOnBoardingExternalTask') ||
                      (statusData?.inProgressTask === 'APIGOnBoardingExternalTask' &&
                        statusData?.errorTask !== 'APIGOnBoardingExternalTask')
                    }
                    status={applicationStatus}
                  />
                  <StatusData
                    isApproved={
                      statusData?.completedTaskList?.includes('apigOnBoardingExternalTask') && isCheckerApproved
                    }
                    title={'Api Gateway Onboarding'}
                    subTitleKey={'Status: '}
                    subTitleValue={
                      statusData?.completedTaskList?.includes('apigOnBoardingExternalTask') ||
                      statusData?.completedTaskList?.includes('APIGOnBoardingExternalTask')
                        ? 'Onboarded on Api Gateway'
                        : (statusData?.errorTask === 'apigOnBoardingExternalTask' ||
                            statusData?.errorTask === 'APIGOnBoardingExternalTask') &&
                          statusData?.errorReason?.length > 0
                        ? getErrorReason(statusData?.errorReason)
                        : ''
                    }
                    subSubTitleKey={''}
                    subSubTitleValue={''}
                    show={
                      statusData?.completedTaskList?.includes('apigOnBoardingExternalTask') ||
                      statusData?.completedTaskList?.includes('APIGOnBoardingExternalTask') ||
                      statusData?.errorTask === 'apigOnBoardingExternalTask' ||
                      statusData?.errorTask === 'APIGOnBoardingExternalTask' ||
                      statusData?.inProgressTask === 'apigOnBoardingExternalTask' ||
                      statusData?.inProgressTask === 'APIGOnBoardingExternalTask'
                    }
                  />
                </Box>
                <Box direction="row">
                  <StatusStateIcon
                    isApproved={
                      statusData?.completedTaskList?.includes('channelIdConfigExternalTask') && isCheckerApproved
                    }
                    show={
                      (statusData?.completedTaskList?.length > 0 &&
                        statusData?.completedTaskList?.includes('channelIdConfigExternalTask')) ||
                      statusData?.inProgressTask === 'channelIdConfigExternalTask' ||
                      statusData?.errorTask === 'channelIdConfigExternalTask'
                    }
                    isProgress={
                      statusData?.inProgressTask === 'channelIdConfigExternalTask' &&
                      statusData?.errorTask !== 'channelIdConfigExternalTask'
                    }
                    status={applicationStatus}
                  />
                  <StatusData
                    isApproved={
                      statusData?.completedTaskList?.includes('channelIdConfigExternalTask') && isCheckerApproved
                    }
                    title={'Channel ID Creation'}
                    subTitleKey={'Channel ID: '}
                    subTitleValue={
                      statusData?.completedTaskList?.includes('channelIdConfigExternalTask') && isCheckerApproved
                        ? statusData?.channelId
                        : 'NA'
                    }
                    subSubTitleKey={''}
                    subSubTitleValue={''}
                    show={
                      statusData?.completedTaskList?.includes('channelIdConfigExternalTask') ||
                      statusData?.errorTask === 'channelIdConfigExternalTask' ||
                      statusData?.inProgressTask === 'channelIdConfigExternalTask'
                    }
                  />
                </Box>
              </ModBox>
            </Box>
          </Box>
          <ModBox marginTop={32} show={statusData?.errorReason?.length > 0 && statusData?.errorTask?.length > 0}>
            <ButtonNew
              type={'secondary'}
              borderWidth={1}
              height={40}
              borderColor={'#0070B6'}
              onPress={onApplicationRetry}
              title={'Retry'}
            />
          </ModBox>
        </Box>
      </ModBox>
      <ModBox {...styles.footer}>
        <Footer onSubmit={onSubmit} />
      </ModBox>
      <ModalDialog
        show={showRetryingLoader}
        onDismiss={onDismiss}
        children={
          <ModBox w={472} h={232} backgroundColor={'WHITE'} borderRadius={8}>
            <SubmittingComponent
              screenType="retryEntityCreation"
              type="resubmit"
              message={getMessage(statusData?.inProgressTask)}
              percentage={
                statusData?.inProgressTask === 'userRegistrationExternalTask'
                  ? 30
                  : statusData?.inProgressTask === 'userRegistrationExternalTask'
                  ? 50
                  : statusData?.inProgressTask === 'configExternalTask'
                  ? 60
                  : statusData?.inProgressTask === 'apigOnBoardingExternalTask'
                  ? 70
                  : statusData?.inProgressTask === 'channelIdConfigExternalTask'
                  ? 100
                  : 70
              }
            />
          </ModBox>
        }
        type="CenteredWrap"
      />
    </>
  )
}

export default CheckerStatus
